
import React, { useState, useEffect,useRef } from "react";
import {
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
  IconButton,
  Paper,
  InputBase,
  Menu, MenuItem,
  Pagination,
  CircularProgress
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import ExportDropdown from "../../../../components/ExportDropdown";
import CustomText, { textStyles } from "../../../../components/CustomText";
import StatusDropdown from "../../../../components/StatusDropdown";
import { useTranslation } from "react-i18next";
import DetailsDrawer from "./DetailsDrawer";
import PayExpenseModal from "./PayExpenseModal";
import { useSelector } from "react-redux";
import { decryptToken } from "../../../../Utlis/Encryption.js";
import { BASE_URL } from "../../../../components/BaseUrl.js";
import FilterListIcon from "@mui/icons-material/FilterList"; // 🔹 new filter icon
import FilterDrawer from "./FilterDrawer.js";
import TruncatedCell from "../../../../components/TruncatedCell.js";
import emptypayment from "../../../../assets/emptypayment.png";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ExportExpensesExcel from "./ExpenseExcel.js";
import ExportExpensesPDF from "./ExpensePdf.js";
import { pdf } from "@react-pdf/renderer";
import { useCompanyProfile } from "../../../../components/CompanyProfile";
import {toast,Toaster} from 'react-hot-toast' ;
import back from "../../../../assets/back.svg";
import { useLocation, useNavigate } from 'react-router-dom';
import { convertUTCToLocalDateTime } from "../../../../components/dateTimeUtils.js";

const headerStyle = {
  color: "#44546F",
  fontSize: "15px",
  fontWeight: 600,
  fontFamily: "Poppins, sans-serif",
  whiteSpace: "nowrap",
};

const dataStyle = {
  color: "#172B4D",
  fontSize: "13px",
  fontWeight: 400,
  fontFamily: "Poppins, sans-serif",
  whiteSpace: "nowrap",
};

const ReimbursementRequest = () => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [payModalOpen, setPayModalOpen] = useState(false);
  const [paySelectedRow, setPaySelectedRow] = useState(null);
const [loading, setLoading] = useState(false);
const [initialLoading, setInitialLoading] = useState(true);
const navigate=useNavigate();
const location = useLocation();
  const fromDashboard = location.state?.fromDashboard;
  // 🔹 API Data State
  const [expenses, setExpenses] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    pages: 1,
    total: 0,
  });
const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
  const [filters, setFilters] = useState({ status: "", startDate: "", endDate: "",  workerId: "",  });
  const token = useSelector((state) => state.auth.token);
     const decryptedToken = token ? decryptToken(token) : null;




  const fetchExpenses = async (
    page = 1,
    query = "",
    isInitial = false,
    appliedFilters = filters
  ) => {
    try {
      if (isInitial) {
        setInitialLoading(true);
      } else {
        setLoading(true);
      }

      // 🔹 Build filter query string
      let filterQuery = "";
      if (appliedFilters.status) filterQuery += `&status=${appliedFilters.status}`;
      // if (appliedFilters.startDate) filterQuery += `&startDate=${appliedFilters.startDate}`;
      // if (appliedFilters.endDate) filterQuery += `&endDate=${appliedFilters.endDate}`;
    if (appliedFilters.startDate) filterQuery += `&from=${appliedFilters.startDate}`;
if (appliedFilters.endDate) filterQuery += `&to=${appliedFilters.endDate}`;
if (appliedFilters.workerId && appliedFilters.workerId !== "all")
  filterQuery += `&worker=${appliedFilters.workerId}`;
      const res = await fetch(
        `${BASE_URL}/company-admin/expenses?page=${page}&limit=5${
          query ? `&q=${query}` : ""
        }${filterQuery}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      const result = await res.json();
      if (!result.error) {
        setExpenses(result.data);
        setPagination(result.pagination);
      }
    } catch (err) {
      console.error("Error fetching expenses:", err);
    } finally {
      if (isInitial) {
        setInitialLoading(false);
      } else {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchExpenses(1, searchTerm, true, filters);
  }, []);

  const firstLoad = useRef(true);

  useEffect(() => {
    if (firstLoad.current) {
      firstLoad.current = false;
      return;
    }
    const delayDebounce = setTimeout(() => {
      fetchExpenses(1, searchTerm, false, filters);
    }, 500);
    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  useEffect(() => {
    if (!initialLoading) {
      fetchExpenses(pagination.page, searchTerm, false, filters);
    }
  }, [pagination.page]);
  const handleSelect = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

// Remove setSelectedRow from handleMenuOpen
const handleMenuOpen = (e, row) => {
  setAnchorEl(e.currentTarget);
  setSelectedRow(row); // ❌ remove this
};

// Pass the row into handleView
const handleView = (row) => {
  setSelectedRow(row);
  setDrawerOpen(true);
  setAnchorEl(null);
};

// Handle Pay action
const handlePay = (row) => {
  setPaySelectedRow(row);
  setPayModalOpen(true);
  setAnchorEl(null);
};

 const handleMenuClose = () => {
  setAnchorEl(null);
  // 🚫 don't reset selectedRow here
};

  const formatDateTime = (dateString) => {
  const formatted = convertUTCToLocalDateTime(dateString, {
    locale: "en-GB",
    formatOptions: {
      day: "2-digit",
      month: "short",
      year: "numeric",
    },
  });
  return formatted === "—" ? "-" : formatted;
};

const fetchAllExpenses = async () => {
  try {
    let url = `${BASE_URL}/company-admin/expenses?no_pagination=true&sort=created_at:desc`;

    // 🔹 search
    if (searchTerm) url += `&q=${searchTerm}`;

    // 🔹 filters
    if (filters.status) url += `&status=${filters.status}`;
    if (filters.startDate) url += `&from=${filters.startDate}`;
    if (filters.endDate) url += `&to=${filters.endDate}`;
    if (filters.workerId && filters.workerId !== "all")
  url += `&worker=${filters.workerId}`;

    console.log("📡 Fetching ALL expenses:", url);

    const res = await fetch(url, {
      headers: { Authorization: `Bearer ${decryptedToken}` },
    });

    const json = await res.json();

    if (json.error) {
      console.error("❌ Error in export:", json.message);
      return [];
    }

    const allExpenses = json.data || [];

    return allExpenses.map((item) => {
      const formattedExpenseDate = item.date_of_expense
        ? convertUTCToLocalDateTime(item.date_of_expense, {
            locale: "en-GB",
            formatOptions: {
              day: "2-digit",
              month: "short",
              year: "numeric",
            },
          })
        : "-";

      return ({
      id: item.id,
      worker: item.worker?.name || "-",
      amount: `${item.amount}`,
      currency: item.currency || item.expense?.currency || "USD",
      date: formattedExpenseDate === "—" ? "-" : formattedExpenseDate,
      description: item.description || "-",
      proof: item.receipt_url ? "Available" : "-",
      status: item.status || "-",
      comments: item.decision_note || "-",
    })});

  } catch (err) {
    console.error("❌ Fetch all expenses failed:", err);
    return [];
  }
};

const getCurrencySymbol = (currencyCode) => {
  if (!currencyCode) return "";
  switch (currencyCode.toUpperCase()) {
    case "USD":
      return "$";
    case "EUR":
      return "€";
    default:
      return ""; // no text fallback if it's another currency
  }
};

const { logoBase64, } = useCompanyProfile(decryptedToken);
  return (
    <>
              {fromDashboard && (
  <Box
    sx={{
      border: '1px solid #E4E6EF',
      borderRadius: 2,
      px: 2,
      backgroundColor: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      minHeight: 55,
      mb: 2,
      ml:1, mr:1
    }}
  >
    <Box
      sx={{ display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer' }}
      onClick={() => navigate(-1)}
    >
      <img src={back} style={{ width: 30, height: 30 }} />
      <CustomText
        sx={{
          ...textStyles.h1,
          fontWeight: 500,
          fontSize: '14px',
          color: '#626F86',
          textAlign: 'center'
        }}
      >
        {t('companyAdmin')} 
      </CustomText>
    </Box>
  </Box>
)}
    <Box
      sx={{
        backgroundColor: "#fff",
        borderRadius: 2,
        border: "2px solid #091E4224",
        py: 2,
        px: 0,
        ml: 1,
        mr: 1,
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          pb: 2,
          px: 2,
          borderBottom: "2px solid #091E4224",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
                      <Box sx={{ flex:1, display: "flex", alignItems: "center", gap: 1 }}>
        
        <CustomText
          sx={{
            ...textStyles.h1,
            fontWeight: 600,
            fontSize: "18px",
            color: "#003149",
            textAlign: "left",
          }}
        >
          {t("reimbursementRequest.heading")}
        </CustomText>
{!initialLoading && loading && (
  <CircularProgress size={18} sx={{ ml: 1 }} />
)}
</Box>
        <Box
          sx={{
            px: 1,
            py: 0.2,
            borderRadius: 1,
            height: 34,
            border: "2px solid #091E4224",
            display: "flex",
            alignItems: "center",
            minWidth: 250,
            maxWidth: 300,
          }}
        >
          <InputBase
            placeholder={t("searchByDescription")}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{
              fontSize: 14,
              fontFamily: "Poppins, sans-serif",
              color: "#939393",
              width: "100%",
            }}
          />
          <SearchIcon sx={{ fontSize: 20, color: "#888", ml: 1 }} />
        </Box>
      <ExportDropdown
  onDownloadPDF={async () => {
    const allExpenses = await fetchAllExpenses();
    const blob = await pdf(<ExportExpensesPDF data={allExpenses} logo={logoBase64} />).toBlob();
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `Reimbursement_Requests ${new Date()
          .toISOString()
          .slice(0, 10)}.pdf`;
    link.click();
  }}
  onDownloadExcel={async () => {
    const allExpenses = await fetchAllExpenses();
    ExportExpensesExcel(allExpenses);
  }}
/>
          {filters.status || filters.startDate || filters.endDate || (filters.workerId && filters.workerId !== "all") ? (
  <Box
    sx={{
      position: "relative",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: 34,
      height: 34,
      borderRadius: 1,
      bgcolor: "#1976d2", // blue when applied
    }}
  >
    {/* Filter Icon (white) */}
    <FilterAltIcon sx={{ color: "white", fontSize: 20 }} />

    {/* Cross Icon (to clear filters) */}
    <IconButton
      size="small"
      onClick={() => {
        setFilters({ status: "", startDate: "", endDate: "",  workerId: "",  }); // reset
        setPagination((prev) => ({ ...prev, page: 1 }));
        fetchExpenses(1, searchTerm, false, { status: "", startDate: "", endDate: "" });
      }}
      sx={{
        position: "absolute",
        top: -6,
        right: -6,
        bgcolor: "white",
        width: 18,
        height: 18,
        border: "1px solid #C4C4C4",
        "&:hover": { bgcolor: "#f5f5f5" },
      }}
    >
      <CloseRoundedIcon sx={{ fontSize: 14, color: "#333" }} />
    </IconButton>
  </Box>
) : (
  <IconButton
    onClick={() => setFilterDrawerOpen(true)}
    sx={{
      border: "1px solid #C4C4C4",
      borderRadius: 1,
      width: 34,
      height: 34,
    }}
  >
    <FilterAltIcon />
  </IconButton>
)}
     
      </Box>

      {/* Table */}
      <Box sx={{ overflowX: "auto", width: "100%" }}>
        <Table>
          <TableHead>
            <TableRow>
    
          <TableCell sx={headerStyle}>{t("reimbursementRequest.tableHeaders.id")}</TableCell>
<TableCell sx={headerStyle}>{t("reimbursementRequest.tableHeaders.workerName")}</TableCell>
<TableCell sx={headerStyle}>{t("reimbursementRequest.tableHeaders.amount")}</TableCell>
<TableCell sx={headerStyle}>{t("reimbursementRequest.tableHeaders.dateOfExpense")}</TableCell>
<TableCell sx={headerStyle}>{t("reimbursementRequest.tableHeaders.description")}</TableCell>
<TableCell sx={headerStyle}>{t("reimbursementRequest.tableHeaders.proof")}</TableCell>
<TableCell sx={headerStyle}>{t("reimbursementRequest.tableHeaders.status")}</TableCell>
<TableCell sx={headerStyle}>{t("reimbursementRequest.tableHeaders.comments")}</TableCell>
<TableCell sx={headerStyle}>{t("reimbursementRequest.tableHeaders.action")}</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
          {initialLoading ? (
    <TableRow>
      <TableCell colSpan={10} sx={{ textAlign: "center" }}>
        <CircularProgress size={40} />
      </TableCell>
    </TableRow>
            ) : expenses.length === 0 ? (
        <TableRow>
                 <TableCell colSpan={10}>
                    <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                py: 5,
              }}
            >
              <img
                src={emptypayment}
                alt="No Data"
                style={{ width: 200, marginBottom: 16 }}
              />
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontWeight: 500,
                  fontSize: "16px",
                  color: "#003149",
                }}
              >
                {t("empty.no_user")}
              </CustomText>
            </Box>
            </TableCell>
            </TableRow>
         
            ) : (
              expenses.map((item) => (
                <TableRow key={item.id}>
                
                  <TableCell sx={dataStyle}>{item.id}</TableCell>
                  <TableCell sx={dataStyle}>{item.worker?.name}</TableCell>
                  <TableCell sx={dataStyle}>
                    {/* {item.amount} {item.currency} */}
                     {getCurrencySymbol(item.currency)}{" "}{item.amount}
                  </TableCell>
                  <TableCell sx={dataStyle}>
                              {formatDateTime(item.date_of_expense)}

                  </TableCell>
                  <TableCell sx={dataStyle}>
                    {/* {item.description} */}
                              <TruncatedCell text={item.description} />
                    
                    </TableCell>
                 {/* <TableCell sx={dataStyle}>
  {item.receipt_url ? (
    <IconButton
      size="small"
      onClick={() => window.open(item.receipt_url, "_blank")}
    >
      <VisibilityIcon fontSize="small" />
    </IconButton>
  ) : (
    "-"
  )}
</TableCell> */}
<TableCell sx={dataStyle}>
{item.receipt_url ? (
<IconButton
size="small"
onClick={async () => {
try {
const res = await fetch(item.receipt_url, { method: "HEAD" });


if (!res.ok) {
throw new Error("File not found");
}


window.open(item.receipt_url, "_blank");
} catch (error) {
toast.error(t("file_not_found_error"));
}
}}
>
<VisibilityIcon fontSize="small" />
</IconButton>
) : (
"-"
)}
</TableCell>
                  <TableCell sx={dataStyle}>
                              <Box sx={{ pointerEvents: "none" }}>
                    
                    <StatusDropdown currentStatus={item.status} />
                    </Box>
                  </TableCell>
                  <TableCell sx={dataStyle}>
                    {/* {item.decision_note || "-"} */}
                     <TruncatedCell text={item.decision_note || "-"}/>

                  </TableCell>
                  <TableCell>
                    <IconButton
                      size="small"
                 onClick={(e) => handleMenuOpen(e, item)}
                    >
                      <MoreVertIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>

        {/* Pagination from backend */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "center",
            mt: 2,
          }}
        >
          <Pagination
            count={pagination.pages}
            page={pagination.page}
            onChange={(e, value) =>
              setPagination((prev) => ({ ...prev, page: value }))
            }
            shape="rounded"
            color="primary"
            size="small"
            sx={{
              "& .MuiPaginationItem-root": {
                fontFamily: "Poppins, sans-serif",
                fontSize: 13,
                fontWeight: 500,
              },
              "& .Mui-selected": {
                backgroundColor: "#E9F3FF",
                color: "#006EC2",
              },
            }}
          />
        </Box>

        {/* Row Menu */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          transformOrigin={{ vertical: "top", horizontal: "center" }}
        >
<MenuItem
  onClick={() => handleView(selectedRow)}   // ✅ use selectedRow
  sx={{ fontSize: 14, fontFamily: "Poppins, sans-serif" }}
>
  {t("unvalidatedPunches.tableActions.view")}
</MenuItem>
{selectedRow?.status === "approved" && (
  <MenuItem
    onClick={() => handlePay(selectedRow)}
    sx={{ fontSize: 14, fontFamily: "Poppins, sans-serif" }}
  >
    {t("reimbursementRequest.pay") || "Pay"}
  </MenuItem>
)}

        </Menu>
      </Box>

      <FilterDrawer
        open={filterDrawerOpen}
        onClose={() => setFilterDrawerOpen(false)}
        filters={filters}
        setFilters={setFilters}
     onApplyFilters={(newFilters) => {
    setFilters(newFilters);
    setPagination((prev) => ({ ...prev, page: 1 }));
    fetchExpenses(1, searchTerm, false, newFilters); // ✅ small loader instead
  }}
      />
      <DetailsDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
  data={selectedRow} 
    onSuccess={() => {
    // refresh list after edit
    fetchExpenses(pagination.page, searchTerm, false, filters);
  }}    // 🔹 selected row is passed here
      />
      <PayExpenseModal
        open={payModalOpen}
        onClose={() => {
          setPayModalOpen(false);
          setPaySelectedRow(null);
        }}
        expense={paySelectedRow}
        onSuccess={() => {
          // refresh list after payment
          fetchExpenses(pagination.page, searchTerm, false, filters);
        }}
      />
    </Box>
    </>
  );
};

export default ReimbursementRequest;




